import { required, email, regex } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver, setInteractionMode } from "vee-validate"
setInteractionMode("eager")

import { mapGetters } from 'vuex';

const reporte = {
    components: { ValidationObserver, ValidationProvider },
    data: () => ({
        paises: [],
        internos: [],
        clientes: [],
        minutas: [],
        form: {
            campana: null,
            centro: null,
            segmento: null,
            pais: null,
            dateStart: null,
            dateEnd: null,
            selectedAttendee: null,
            export: false,
            periocidad: 'S'
        },
        headerMinuta: [
            { text: 'Responable', value: 'responsable' },
            { text: 'Nombre Minuta', value: 'nombre_minuta' },
            { text: 'Fec. envio de encuesta', value: 'fecha_envio_encuesta' },
            { text: 'Fec. respuesta de encuesta', value: 'fecha_respuesta_encuesta' },
            { text: 'Pais', value: 'pais' },
            { text: 'Sede', value: 'centro' },
            { text: 'Segmento', value: 'segmento' },
            { text: 'Campanaña', value: 'campana' },
            { text: 'Cliente', value: 'cliente' },
        ],
        isSelectedBtnMes: false,
        isSelectedBtnSemana: false,
        isSelectedBtnDia: false,
        loadingMinutas: false,
        loadingBtnExport: false,
        loadingBtnFilter: false,
        dialogFiltros: false,
        fechaStartStatus: false,
        fechaEndStatus: false,
        selectedMeetingType: null,
        fechas: [],
        historial: [],
        meses: [],
        meetingTypes: [
            { text: 'Interno', value: 'interno' },
            { text: 'Cliente', value: 'cliente' }
        ],
        selectedAttendee: null,
        dialogLeyenda: false,
    }),
    mounted() {
        this.fechasFiltros();
        this.isSelectedBtnSemana = true;
        // this.fetchInternos();
        // this.fetchClients();
        this.createEvent();
    },
    computed: {
        ...mapGetters(['getPaises', 'getCentros', 'getSegmentos', 'getCampanas']),
        filteredCentros() {
            return this.getCentros.filter(centro => centro.inPaisId === this.form.pais).sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion));
        },
        filteredSegmentos() {
            let segmentos = []
            let uniqueSegmento = []

            if (Array.isArray(this.form.centro) && this.form.centro.length > 0) {
                segmentos = this.getCampanas.filter(item => this.form.centro.includes(item.in_CentroId)).map(item => item.in_SegmentoId);
                uniqueSegmento = [...new Set(segmentos)];
            }
            return this.getSegmentos.filter(item => uniqueSegmento.includes(item.Id)).sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion));
        },
        filteredCampanas() {
            let campanas = [];

            if (Array.isArray(this.form.segmento) && this.form.segmento.length > 0) {
                campanas = this.getCampanas.
                    filter(item => this.form.centro.includes(item.in_CentroId)).
                    filter(item => this.form.segmento.includes(item.in_SegmentoId));
            }
            return campanas.sort((a, b) => a.vc_Descripcion.localeCompare(b.vc_Descripcion));;;
        },
        formattedConvocados() {
            return this.filteredConvocados().map(convocado => {
                return {
                    ...convocado,
                    fullName: `${convocado.vc_Nombres} ${convocado.vc_ApePaterno} ${convocado.vc_ApeMaterno}(${convocado.tipo})`
                };
            });
        },
    },
    methods: {
        fechasFiltros() {
            var today = new Date();
            var primerDia = new Date(today.getFullYear(), today.getMonth(), 1);
            var ultimoDia = new Date(today.getFullYear(), today.getMonth() + 1, 0);

            this.form.dateStart = this.formatDate(primerDia);
            this.form.dateEnd = this.formatDate(ultimoDia);
        },
        formatDate(date) {
            var year = date.getFullYear();
            var month = String(date.getMonth() + 1).padStart(2, '0');
            var day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        },
        procesarMes(){
            this.isSelectedBtnMes = true;
            this.isSelectedBtnSemana = false;
            this.isSelectedBtnDia = false;
            this.form.periocidad = 'M';
            this.createEvent();
        },
        procesarSemana(){
            this.isSelectedBtnMes = false;
            this.isSelectedBtnSemana = true;
            this.isSelectedBtnDia = false;
            this.form.periocidad = 'S';
            this.createEvent();
        },
        procesarDia(){
            this.isSelectedBtnMes = false;
            this.isSelectedBtnSemana = false;
            this.isSelectedBtnDia = true;
            this.form.periocidad = 'D';
            this.createEvent();
        },
        filteredConvocados() {
            if (!this.form.campana || !this.selectedMeetingType) {
                return []; // No se ha seleccionado ninguna campaña o tipo de reunión
            }
            return this.getFilteredConvocados(this.form.campana, this.selectedMeetingType);
        },
        async fetchInternos() {
            try {
                const response = await this.$axios.get('getInternos');
                this.internos = response.data.all;
            } catch (error) {
                console.error('Error al obtener los internos:', error);
            }
        },
        async fetchClients() {
            try {
                const response = await this.$axios.get('getClients');
                this.clientes = response.data.all;
            } catch (error) {
                console.error('Error al obtener los clientes:', error);
            }
        },
        getFilteredConvocados(campanaId, meetingType) {
            if (!campanaId) {
                return [];
            }
            const campanaIdNum = Number(campanaId);
            // Filtrar internos por campaña seleccionada
            let internosFiltrados = this.internos.filter(interno =>
                interno.campanas.some(campana => campana.in_CampanaId === campanaIdNum)
            ).map(interno => ({
                ...interno,
                tipo: 'interno'
            }));

            // Filtrar clientes por campaña seleccionada
            let clientesFiltrados = this.clientes.filter(cliente =>
                cliente.campanas.some(campana => campana.in_CampanaId === campanaIdNum)
            ).map(cliente => ({
                ...cliente,
                tipo: 'cliente'
            }));

            if (meetingType === 'interno') {
                // Si el tipo de reunión es 'interno', devolver solo los internos filtrados por campaña
                return internosFiltrados;
            } else if (meetingType === 'cliente') {
                // Si el tipo de reunión es 'cliente', devolver internos y clientes filtrados por campaña
                return [...internosFiltrados, ...clientesFiltrados];
            }

            // Si el tipo de reunión no es 'interno' ni 'cliente', devolver internos y clientes filtrados por campaña
            return [...internosFiltrados, ...clientesFiltrados];
        },
        limpiar() {
            this.form = {
                title: '',
                dateMeet: [],
                recurrence_pattern: '',
                startTime: '',
                endTime: '',
                campana: ''
            },
                this.detailsMeet = null,
                this.selectedMeetingType = null,
                this.selectedAttendee = null
        },
        getNameByid(id) {
            var data = '';
            data = this.internos.filter(item => item.id == id);
            if (data.length == 0) {
                data = this.clientes.filter(item => item.id == id);
            }

            if (data.length == 0) {
                return '';
            }

            return data[0].vc_Nombres + " " + data[0].vc_ApePaterno + " " + data[0].vc_ApeMaterno;

        },
        async createEvent(reset) {
            this.loadingMinutas = false;
            this.loadingBtnFilter = true;
            this.form.selectedAttendee = this.selectedAttendee;
            try {
                const response = await this.$axios.post('/reporte/encuestas', this.form);
                this.fechas = response.data.fechas;
                this.historial = response.data.historial;
                this.meses = response.data.meses;
                
            } catch (error) {
                console.log('Hubo un error en los datos');
            }
            this.loadingBtnFilter = false;
            this.dialogFiltros = false
        },
        styleByValor(valor){
            if(valor > 0 && valor <= 6 ){
                return {
                    backgroundColor: '#ff4949'
                }
            }

            if(valor > 6 && valor <= 8 ){
                return {
                    backgroundColor: '#ffff54'
                }
            }

            if(valor > 8 && valor <= 10 ){
                return {
                    backgroundColor: '#69c76d'
                }
            }

            if(valor == -1){
                return {
                    backgroundColor: '#cdcdcd'
                }
            }

        },
        styleheader(){
            return {
                backgroundColor: '#008000',
                color: '#FFFFFF'
            }
        },
        
        groupByMes() {
            var fechas = this.fechas;
            // Convertir las fechas a objetos Date
            const fechasDate = fechas.map(fecha => new Date(fecha));
        
            // Función para obtener el número de la semana de una fecha
            function obtenerSemana(fecha) {
                const inicioAno = new Date(fecha.getFullYear(), 0, 1);
                const diferencia = fecha - inicioAno;
                const milisegundosPorDia = 1000 * 60 * 60 * 24;
                const diaDelAno = Math.floor(diferencia / milisegundosPorDia);
                return Math.ceil((diaDelAno + 1) / 7);
            }
        
            // Agrupar las fechas por semana
            const semanas = fechasDate.reduce((acumulador, fecha) => {
                const semana = obtenerSemana(fecha);
                // Convertir la semana a un formato adecuado (por ejemplo, 2025-W01)
                const semanaClave = `${fecha.getFullYear()}-W${String(semana).padStart(2, '0')}`;
                
                if (!acumulador[semanaClave]) {
                    acumulador[semanaClave] = [];
                }
        
                acumulador[semanaClave].push(fecha.toISOString().split('T')[0]);  // Guardar solo la fecha en formato 'YYYY-MM-DD'
                return acumulador;
            }, {});
        
            return semanas;
        },
        async exportar() {

            let linkDescarga;
            let tipoDatos = 'application/vnd.ms-excel';
            let tablaDatos = document.getElementById('tableEncuestas');
            let tablaHTML = tablaDatos.outerHTML;

            
            var nombreArchivo = nombreArchivo ? nombreArchivo + '.xlsx' : 'Reporte_encuestas.xlsx';
            var position = tablaHTML.indexOf("</table>");
            position += 8;
            tablaHTML= tablaHTML.slice(0, position);
            tablaHTML = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${1}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>${tablaHTML}</body></html>`;

            linkDescarga = document.createElement("a");
            document.body.appendChild(linkDescarga);

            if (navigator.msSaveOrOpenBlob) {
                let blob = new Blob(['\ufeff', tablaHTML], {
                  type: tipoDatos
                });
                navigator.msSaveOrOpenBlob(blob, nombreArchivo);
            } else {
                // Crear el link al archivo
                linkDescarga.href = 'data:' + tipoDatos + ', ' + tablaHTML;
            
                // Setear el nombre de archivo
                linkDescarga.download = nombreArchivo;
            
                //Ejecutar la función
                linkDescarga.click();
            }



            this.form.export = true;
            this.loadingBtnExport = true;
            this.form.selectedAttendee = this.selectedAttendee;
            
            if(this.form.dateStart == null || this.form.dateEnd == null){
                this.$toast.warning('seleccione un rango de fechas', {
                    timeout: 3436,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: true,
                    draggablePercent: 0.38,
                    showCloseButtonOnHover: true,
                    hideProgressBar: false,
                    closeButton: false,
                    icon: true,
                    rtl: false
                });

                this.form.export = false;
                this.loadingBtnExport = false;
                return false;
            }

            // try {
            //     const response = await this.$axios.post('/reporte/encuestas', this.form )
                
            //     window.open("http://127.0.0.1:8002/"+ response.data.path, '_blank');
            // } catch (error) {
            //     console.log('Hubo un error en los datos');
            //     this.form.export = false;
            //     this.loadingBtnExport = false;
            // }
            this.form.export = false;
            this.loadingBtnExport = false;
        },
        changePais(){
            this.form.campana = null;
            this.form.centro = null;
            this.form.segmento = null;
            this.form.selectedAttendee = null;
            this.selectedAttendee = null;

        },
        changeCentro(){
            this.form.campana = null;
            this.form.segmento = null;
            this.form.selectedAttendee = null;
            this.selectedAttendee = null;

        },
        changeSegmento(){
            this.form.campana = null;
            this.form.selectedAttendee = null;
            this.selectedAttendee = null;

        },
        changeCampana(){
            this.form.selectedAttendee = null;
            this.selectedAttendee = null;
        }
    },
}


export default reporte;